import React, { createContext, useState, useEffect } from 'react';
import useBenefitDetails from '../hooks/useBenefitDetails';
import useCurrentUser from '../hooks/useCurrentUser';

export const BenefitDetailsContext = createContext({
  state: { benefitDetails: null, tangeloBenefitDetails: null },
  actions: { setBenefitDetails: () => {}, setTangeloBenefitDetails: () => {} },
});

export const BenefitDetailsContextProvider = ({ children }) => {
  const { userID } = useCurrentUser();

  const { data: benefitDetailsData, isLoading, error } = useBenefitDetails(userID);

  const [tangeloBenefitDetails, setTangeloBenefitDetails] = useState(null);
  const [benefitDetails, setBenefitDetails] = useState(null);
  const [mainBenefitDetails, setMainBenefitDetails] = useState(null);

  const test = {
    auth_end_date: null,
    auth_start_date: null,
    benefit_id: 60,
    benefit_name: 'NYP All Campus Referral (6 Months)',
    meal_grocery_auth_no: null,
    no_of_meals: 12,
    provider_name: 'NewYork-Presbyterian',
    rd_authorized_no: null,
    status: 'Incomplete application',
  };

  const test2 = {
    auth_end_date: null,
    auth_start_date: null,
    benefit_id: null,
    benefit_name: null,
    meal_grocery_auth_no: null,
    no_of_meals: null,
    provider_name: null,
    rd_authorized_no: null,
    status: 'Pending Evaluation',
  };

  const test3 = [
    {
      auth_end_date: '2025-02-03',
      auth_start_date: null,
      benefit_id: null,
      benefit_name: null,
      meal_grocery_auth_no: null,
      no_of_meals: null,
      provider_name: null,
      rd_authorized_no: null,
      status: 'Ready for Re-Auth',
    },

    {
      auth_end_date: null,
      auth_start_date: null,
      benefit_id: 60,
      benefit_name: 'NYP All Campus Referral (6 Months)',
      meal_grocery_auth_no: null,
      no_of_meals: 12,
      provider_name: 'NewYork-Presbyterian',
      rd_authorized_no: null,
      status: 'MNT Session Needed',
    },

    {
      auth_end_date: '2025-02-05',
      auth_start_date: '2024-01-29',
      benefit_id: 60,
      benefit_name: 'NYP All Campus Referral (6 Months)',
      meal_grocery_auth_no: null,
      no_of_meals: 12,
      provider_name: 'NewYork-Presbyterian',
      rd_authorized_no: null,
      status: 'Activated',
    },

    // {
    //     auth_end_date: '2025-02-29',
    //     auth_start_date: '2024-02-29',
    //     benefit_id: 60,
    //     benefit_name: 'NYP All Campus Referral (6 Months)',
    //     meal_grocery_auth_no: null,
    //     no_of_meals: 12,
    //     provider_name: 'NewYork-Presbyterian',
    //     rd_authorized_no: null,
    //     status: 'Active',
    // }
  ];

  useEffect(() => {
    if (!isLoading && !error) {
      // console.log('Fetched benefitDetailsData:', benefitDetailsData);
      if (benefitDetailsData && benefitDetailsData.data) {
        if (Array.isArray(benefitDetailsData.data)) {
          setBenefitDetails(benefitDetailsData.data);
        } else {
          setBenefitDetails([benefitDetailsData.data]);
        }
        // setBenefitDetails(benefitDetailsData.data);
        // setBenefitDetails(test3);
      }
      // setTangeloBenefitDetails(benefitDetailsData.data[0]);
    } else if (error) {
      console.error('Error fetching benefit details:', error);
    }
  }, [benefitDetailsData, isLoading, error]);

  useEffect(() => {
    if (Array.isArray(benefitDetails)) {
      const temp = filterMainBenefitDetails(benefitDetails);
      // console.log('chosen benefit: ', temp);
      setMainBenefitDetails(temp);
    }
    // console.log('Updated benefitDetails in context:', benefitDetails);
    // console.log('Updated BenefitDetails in context:', benefitDetailsData);
    // if (benefitDetailsData && benefitDetailsData.data) {
    //     console.log('benefit id in context:', benefitDetails.benefit_id);
    // }
  }, [benefitDetails]);

  return (
    <BenefitDetailsContext.Provider
      value={{
        benefitDetails,
        mainBenefitDetails,
        tangeloBenefitDetails,
        setBenefitDetails,
        setTangeloBenefitDetails,
      }}
    >
      {children}
    </BenefitDetailsContext.Provider>
  );
};

const filterActiveBenefitDetails = (benefitDetailsArray) => {
  if (!Array.isArray(benefitDetailsArray)) {
    return benefitDetailsArray;
  }
  const activeArr = [];
  for (let i = 0; i < benefitDetailsArray.length; i++) {
    if (benefitDetailsArray[i]?.status === 'Active') {
      activeArr.push(benefitDetailsArray[i]);
    }
  }
  return activeArr;
};

const filterAuthEndDateProximityBenefitDetails = (benefitDetailsArray) => {
  if (!Array.isArray(benefitDetailsArray)) {
    return benefitDetailsArray;
  }
  let closestDate = benefitDetailsArray[0];
  for (let i = 0; i < benefitDetailsArray.length; i++) {
    if (benefitDetailsArray[i]?.auth_end_date !== null) {
      if (
        Math.abs(new Date(benefitDetailsArray[i]?.auth_end_date) - new Date()) <
        Math.abs(new Date(closestDate?.auth_end_date) - new Date())
      ) {
        closestDate = benefitDetailsArray[i];
      }
    }
  }
  return closestDate;
};

export const filterMainBenefitDetails = (benefitDetailsArray) => {
  if (!Array.isArray(benefitDetailsArray)) {
    return benefitDetailsArray;
  }
  if (benefitDetailsArray.length === 1) {
    return benefitDetailsArray[0];
  }
  const activeArr = filterActiveBenefitDetails(benefitDetailsArray);
  // console.log('here is activeArr: ', activeArr);
  if (activeArr.length === 0) {
    let temp = filterAuthEndDateProximityBenefitDetails(benefitDetailsArray);
    if (temp?.auth_end_date === null) {
      return benefitDetailsArray[benefitDetailsArray.length - 1];
    } else {
      return temp;
    }
  } else if (activeArr.length === 1) {
    return activeArr[0];
  } else {
    return filterAuthEndDateProximityBenefitDetails(activeArr);
  }
};

export const findBenefitByID = (benefitDetailsArray, benefitID) => {
  if (!Array.isArray(benefitDetailsArray)) {
    return benefitDetailsArray;
  }
  for (let benefit of benefitDetailsArray) {
    if (benefit.benefit_id === benefitID) {
      return benefit;
    }
  }
  return null;
};
